/*
 * ---------------------------------------------------------------------
 * Stream Action Types
 * ---------------------------------------------------------------------
 */
export const SET_ACTIVE_STREAM = "SET_ACTIVE_STREAM";

export const SET_STREAM_LIST = "SET_STREAM_LIST";
